<template>
  <full-width bg="tmsk-sky-blue-bg">
    <centralized>
      <div class="mask-plus-info-container">
        <div class="mask-plus-img-container w-72 h-16 sm:w-60 sm:h-48"></div>
        <div
          data-e2e-attr="mask-plus-info-text"
          class="mask-plus-info w-72 sm:w-3/5"
        >
          <div
            data-e2e-attr="mask-plus-info-new-sizing-text"
            class="mask-plus-info-new-sizing-text"
          >
            New Sizing!
          </div>
          <div
            data-e2e-attr="mask-plus-info-body-text"
            class="mask-plus-info-body-text"
          >
            Check carefully - No refunds or exchanges after collection
          </div>
        </div>
      </div>
      <div
        class="
          flex flex-wrap
          justify-center
          max-w-6xl
          mt-2
          sm:mt-10
          mx-auto
          overflow-hidden
        "
      >
        <div
          class="
            my-2
            sm:my-3
            px-3
            w-full
            sm:w-6/12
            md:w-5/12
            lg:w-5/12
            xl:w-1/3
            flex
          "
        >
          <card
            class="cursor-pointer w-72 wrap:w-96 mx-auto"
            :onClick="
              () => goToExternalLink('https://stayprepared.sg/sizing-guide')
            "
          >
            <template #body>
              <div class="flex flex-row items-center justify-start space-x-4">
                <div class="flex items-center justify-center h-16">
                  <img src="@/assets/img/home-size-chart.png" class="w-20" />
                </div>
                <p class="flex-1 text-xl font-bold tmsk-blue-text">
                  Mask Sizing Guide
                </p>
              </div>
            </template>
          </card>
        </div>
        <div
          class="
            my-2
            sm:my-3
            px-3
            w-full
            sm:w-6/12
            md:w-5/12
            lg:w-5/12
            xl:w-1/3
            flex
          "
        >
          <card
            class="cursor-pointer w-72 wrap:w-96 mx-auto"
            :onClick="() => reroute('CollectFreeMasks')"
          >
            <template #body>
              <div class="flex flex-row items-center justify-start space-x-4">
                <div class="flex items-center justify-center h-16">
                  <img
                    src="@/assets/img/home-collect-free-masks.png"
                    class="w-20"
                  />
                </div>
                <p class="flex-1 text-xl font-bold tmsk-blue-text">
                  Collect Free Masks
                </p>
              </div>
            </template>
          </card>
        </div>
        <div
          v-if="isPreOrderActive"
          class="
            my-2
            sm:my-3
            px-3
            w-full
            sm:w-6/12
            md:w-5/12
            lg:w-5/12
            xl:w-1/3
            flex
          "
        >
          <card
            data-e2e-attr="home-page-pre-order-btn"
            class="cursor-pointer w-72 wrap:w-96 mx-auto"
            :onClick="() => reroute('Purchase')"
          >
            <template #body>
              <div class="flex flex-row items-center justify-start space-x-4">
                <div class="flex items-center justify-center h-16 -ml-16">
                  <img
                    src="@/assets/img/home-pre-order-additional-masks.png"
                    class="h-24 -mb-6"
                  />
                </div>
                <p class="flex-1 text-xl font-bold tmsk-blue-text">
                  Pre-order Additional Masks
                </p>
              </div>
            </template>
          </card>
        </div>
        <div
          class="
            my-2
            sm:my-3
            px-3
            w-full
            sm:w-6/12
            md:w-5/12
            lg:w-5/12
            xl:w-1/3
            flex
          "
        >
          <card
            class="cursor-pointer w-72 wrap:w-96 mx-auto"
            :onClick="() => reroute('LocateVendingMachines')"
          >
            <template #body>
              <div class="flex flex-row items-center justify-start space-x-4">
                <img
                  src="@/assets/img/home-locate-vending-machines.png"
                  class="h-16"
                />
                <p class="flex-1 text-xl font-bold tmsk-blue-text">
                  Locate Vending Machines
                </p>
              </div>
            </template>
          </card>
        </div>
        <div
          class="
            my-2
            sm:my-3
            px-3
            w-full
            sm:w-6/12
            md:w-5/12
            lg:w-5/12
            xl:w-1/3
            flex
          "
        >
          <card
            class="cursor-pointer w-72 wrap:w-96 mx-auto"
            :onClick="
              () => {
                goToExternalLink('https://stayprepared.sg/staymasked/')
              }
            "
          >
            <template #body>
              <div
                class="flex flex-row items-center justify-start h-16 space-x-2"
              >
                <p class="text-xl font-bold tmsk-blue-text">About</p>
                <div>
                  <img
                    src="@/assets/img/staymasked-logo.svg"
                    class="pb-1 wrap:pb-2 wrap:w-64 w-44"
                  />
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
      <div
        class="
          flex flex-col flex-wrap
          items-center
          justify-center
          w-full
          home-page-buttons-container
        "
      >
        <div
          class="
            justify-center
            flex
            w-72
            sm:w-3/4
            p-3
            m-4
            tmsk-blue-border
            contact-us-container
          "
        >
          <div
            class="
              lg:space-x-5
              flex
              justify-center
              xl:justify-between
              w-full
              flex-col
              lg:flex-row
              tmsk-blue-text
              contact-us-container
            "
          >
            <div class="font-bold text-center text-xs mb-2 sm:text-sm">
              CONTACT US
            </div>
            <div class="flex space-x-2 items-start">
              <img
                class="w-4 md:w-6"
                src="@/assets/img/contactUs/telephone-icon.svg"
              />
              <div class="font-bold text-xs sm:text-sm">
                <a href="tel:1800-738-2000">1800 738 2000</a>
                <div>From 9am to 9pm daily</div>
                <div>till {{ collectionEndDate }}, except Public Holidays</div>
              </div>
            </div>
            <div class="flex space-x-2 items-start sm:break-all">
              <img
                class="w-4 md:w-6"
                src="@/assets/img/contactUs/email-icon.svg"
              />
              <a
                class="font-bold text-xs sm:text-sm"
                href="mailto:staymasked@temasekfoundation.org.sg"
                >staymasked@temasekfoundation.org.sg</a
              >
            </div>
          </div>
        </div>
      </div>
    </centralized>
  </full-width>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import beepAPI from '../mixins/beepAPI'
import Centralized from '../components/Layout/Centralized'
import FullWidth from '../components/Layout/FullWidth'
import Card from '../components/Card'
import { COLLECTION_END_DATE } from '../Constants'
import moment from 'moment'

export default {
  name: 'Home',
  metaInfo() {
    return {
      title: 'StayMasked',
      // meta: [
      //   { property: 'og:title', content: 'StayMasked' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'StayMasked' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-01.jpg' }
      // ],
      link: [{ rel: 'canonical', href: window.location.href }],
    }
  },
  components: {
    Centralized,
    FullWidth,
    Card,
  },
  mixins: [beepAPI],
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['isPreOrderActive']),
    ...mapState(['isLoggedIn']),
  },
  watch: {},

  // Lifecycle Hooks
  beforeCreate() {},
  created() {
    this.collectionEndDate =
      moment(COLLECTION_END_DATE).format('dddd, DD MMM YYYY')
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    reroute(name) {
      this.$router.push({ name: name, query: this.$route.query })
    },

    goToExternalLink(url) {
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
.mask-plus-img-container {
  background-image: url('../assets/img/homePage/home-page-mask-img-mobile.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: right;
}

.mask-plus-info-container {
  margin-bottom: 1em;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mask-plus-info-container .mask-plus-info .mask-plus-info-new-sizing-text {
  font-weight: bold;
  position: relative;
  max-width: fit-content;
  color: #cbdb2a;
  font-size: 1.25rem;
}

.mask-plus-info-body-text {
  border-top: 2px solid white;
  color: white;
  width: 100%;
  padding-top: 4px;
  font-size: 1.1rem;
}

.mask-plus-info-container .mask-plus-info {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem 1rem 1rem;
  border-radius: 1rem;
  text-align: center;
  align-items: center;
  margin: 2rem 2rem 0 2rem;
  background: #0083ca;
}
.contact-us-container {
  max-width: 950px;
}
@media only screen and (min-width: 640px) {
  .mask-plus-info-container .mask-plus-info {
    margin: 0;
    max-width: 40%;
  }

  .mask-plus-info-container .mask-plus-info .mask-plus-info-new-sizing-text {
    font-size: 2rem;
  }

  .mask-plus-info-body-text {
    font-size: 1.25rem;
  }

  .mask-plus-img-container {
    background-image: url('../assets/img/homePage/home-page-mask-img-desktop.png');
    margin-right: 1.5rem;
  }

  .mask-plus-info-container {
    flex-direction: row;
  }
}
</style>
